import { CardElement } from '@stripe/react-stripe-js';
import { Box } from '@mui/material';

interface Props {
  disabled?: boolean;
  disableLink?: boolean;
}

export default function CheckoutElementsForm({
  disabled,
  disableLink = true,
}: Props) {
  return (
    <Box width="100%" boxSizing="border-box" sx={{ minWidth: 0 }}>
      <Box
        boxSizing="border-box"
        p={1.5}
        width="100%"
        border={theme => `1px solid ${theme.palette.outlineGrey.main}`}
        bgcolor="#ffffff"
        borderRadius="5px">
        <Box width="100%">
          <CardElement
            options={{
              disableLink,
              disabled,
              style: {
                base: {
                  fontFamily: 'Montserrat, sans-serif',
                },
              },
            }}
          />
        </Box>
      </Box>
    </Box>
  );
}
